import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Page } from '@app/components';
import { IframePage } from '@app/pages/IframePage';
import { BOOKING, BOOKING_LABEL } from '@app/routes/iframe-routes/constants';
import type { NNavigation } from '@app/types';

export const bookingPage: NNavigation.NavigationItem = {
  key: BOOKING,
  icon: <FontAwesomeIcon icon={faIdCard} size="sm" />,
  label: BOOKING_LABEL,
  id: BOOKING,
  'data-testid': 'online-booking',
  path: '/online-booking/*',
  title: '',
  issidebaritem: 'true',
  sidebarparentid: BOOKING,
  element: (
    <Page disableBreadcrumbs hideBackButton>
      <IframePage key={BOOKING} />
    </Page>
  ),
};
